module.exports = __webpack_public_path__ + "static/media/crossImg.32bf9de5.svg";